<template>
  <div>
    <base-header type="gradient-info" class="pb-6 pb-8 pt-5 pt-md-6">
    </base-header>
    <div class="container-fluid mt--7">
      <div class="row justify-content-center">
        <div class="col-xl-10">
          <card shadow type="secondary">
            <div slot="header" class="bg-white border-0">
              <div class="row align-items-center">
                <div class="col-1">
                  <base-button type="primary" size="sm" @click="$router.back()"
                    ><i class="ni ni-bold-left mt-1"></i
                  ></base-button>
                </div>
                <div class="col-8">
                  <h3 class="mb-0">Editar Usuario</h3>
                </div>
              </div>
            </div>
            <template>
              <form-data :data="id"></form-data>
            </template>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import formData from "./form/createOrUpdate.vue";
export default {
  name: "create-users",
  components: {
    formData,
  },
  data() {
    return {
        id: this.$route.params.id
    };
  },
};
</script>

<style>
</style>